import { RouterItemType } from "@/app/index";
import { lazy } from "react";

const LayoutPageEmployees = lazy(() => import("./layout/index"));

export type LoaderDataEmployeesType = {
  action: string;
  source: string;
};

export const loaderDataEmployees = async (args: any) => {
  const url = new URL(args.request.url);
  const action = url.searchParams.get("action");
  const source = url.searchParams.get("source");

  return {
    action,
    source,
  } as LoaderDataEmployeesType;
};

export const routerPageEmployees: RouterItemType = {
  path: "/employees",
  authorize: true,
  element: <LayoutPageEmployees />,
  loader: loaderDataEmployees,
};
